<template>
  <div class="mou-moa-page-wrap my-3">
    <div class="page-head card shadow-sm border-0 mb-3">
      <div class="card-body d-flex align-items-center">
        <span class="head-icon">
          <i class="bi bi-file-earmark-text"></i>
        </span>
        <div>
          <h4 class="font-weight-bold mb-0">MOU / MOA Repository</h4>
          <p class="page-subtitle mb-0">
            Archive of Memoranda of Understanding and Agreement — browse, upload, and view soft copies.
          </p>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">
        <MouMoaList />
      </div>
    </div>
  </div>
</template>

<script>
import MouMoaList from "./components/MouMoaList.vue";

export default {
  name: "MouMoa",
  components: { MouMoaList },
};
</script>

<style scoped>
.page-head { border-radius: 14px !important; }
.head-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(43, 182, 163, 0.12);
  color: #1f8f7f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  margin-right: 1rem;
  flex-shrink: 0;
}
.page-subtitle { color: #768192; font-size: .9rem; margin-top: .15rem; }
.card { border-radius: 14px !important; }
</style>
